'use client';
import { OnbForm } from '@/components/form';
import { pushStepVariables } from '@/redux/flowSlice';
import { pushThirdPartyRedirect } from '@/redux/navigationSlice';
import { RootState } from '@/redux/store';
import { Typography } from '@mui/material';
import { paymentMethod } from '@repo/onb-api';
import { PaymentSelection } from '@repo/ui';
import { formatter } from '@repo/utils';
import { useRouter } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux';
import StepWrapper from './stepWrapper';

export default function PaymentMethod({
  stepname: stepName,
  stepdata: stepData,
}: {
  stepname?: paymentMethod['name'];
  stepdata?: paymentMethod['variables'];
}): React.JSX.Element {
  //@todo this logic should be in the button component
  const dispatch = useDispatch();
  const router = useRouter();
  const policyProduct = useSelector((state: RootState) => state.additionalData.policyProduct);
  const handleSubmit = ({ paymentMethod, cardId }: paymentMethod['variables']) => {
    if (stepName) {
      dispatch(pushStepVariables({ stepName, variable: 'paymentMethod', value: paymentMethod }));
      if (cardId) dispatch(pushStepVariables({ stepName, variable: 'cardId', value: cardId }));
    }
  };
  const debitCardIndex = stepData?.paymentMethods?.findIndex(({ name }) => name === 'DEBIT_CARD') || 0;
  const orderedPaymentMethods = stepData?.paymentMethods
    ?.slice(debitCardIndex)
    .concat(stepData?.paymentMethods?.slice(0, debitCardIndex));
  return (
    <StepWrapper>
      <Typography variant="h1">
        {process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-efectivo' || policyProduct === 'EFECTIVOC'
          ? '¿Cómo querés pagar tu préstamo?'
          : '¿Cómo querés pagar tu compra?'}
      </Typography>
      <OnbForm<paymentMethod> stepName={stepName!} hideSubmit>
        {orderedPaymentMethods?.map(({ name, cards, newCardUrl }) => {
          if (name === 'DEBIT_CARD') {
            const rows = cards?.map(({ id, number, issuer, type }) => (
              <PaymentSelection
                key={`card-${id}`}
                data-testid={`card-${id}`}
                gateway="card"
                title={`${formatter(issuer, 'capitalize')}${type === 'DEBIT' ? ' débito' : ''} **** ${number?.slice(-4)}`}
                onClick={() => handleSubmit({ paymentMethod: 'DEBIT_CARD', cardId: id })}
              />
            ));
            if (newCardUrl)
              rows?.push(
                <PaymentSelection
                  data-testid="card"
                  key={'addDebitCard'}
                  gateway="card"
                  title="Agregá una tarjeta de débito"
                  description="De manera simple y segura, debitaremos la cuota de tu cuenta mensualmente."
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(pushThirdPartyRedirect(newCardUrl));
                    router.push('/third_party');
                  }}
                />,
              );
            return rows;
          }

          if (name === 'CASH') {
            return (
              <PaymentSelection
                data-testid="cash"
                key={'cash'}
                gateway="cash"
                title="En locales habilitados o Pago Digital"
                description="Con tu DNI o Cuponera en RapiPago, Pago Fácil, Mercado Pago, Plus Pagos, Pago Mis Cuentas, Pagos Link, Bapro Pagos y Cobro Express."
                onClick={() => handleSubmit({ paymentMethod: 'CASH' })}
              />
            );
          }
        })}
      </OnbForm>
    </StepWrapper>
  );
}
